import { Employees } from "@stories/pages/Contractor/Employees/Employees";

export const EmployeesView = () => {
  return <Employees />;
};
